module.exports = __webpack_public_path__ + "img/24-hours.dec49a34.svg";